<!--
 * @Author: your name
 * @Date: 2021-03-11 16:02:05
 * @LastEditTime: 2021-08-09 15:38:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_phone\src\views\Product.vue
-->
<template>
  <div class="mook_product">
    <div :style="{ minHeight: height + 'px' }">
      <div class="mook_poster" style="margin-bottom:40px">
        <Poster :ComponData="poster"></Poster>
      </div>
      <div
        class="product_poster"
        v-if="seriesPoster.length > 0 && seriesPoster[0]"
      >
        <Poster :ComponData="[seriesPoster[0]]"></Poster>
      </div>
      <!-- <ProductCarousel :productList="productData"></ProductCarousel> -->
      <div class="product_list" v-if="productData.length > 0">
        <div class="product_item" v-for="(item,index) in productData" :key="index"  @click="onStarItemPage(item.id,item,index)">
          <div class="product_image" :style="{backgroundImage:'url('+item.imageUrl+')'}">
            <!-- <img class="auto-img" :src="item.imageUrl" /> -->
          </div>
          <div class="title">
            <div class="title_p">{{ item.title }}</div>
            <div class="title_bg" v-for="(itembg,indexbg) in 3" :key="indexbg" v-bind:style="{ top: indexbg*26+'px'}"></div>
          </div>
          <div class="price" v-if="item.price">
            {{ item.price ? item.price : 0 }}{{ lange == "Ch" ? "元" : "円" }}
          </div>
          <!-- <div
            class="comprehend"
            @click="onStarItemPage(item.id,item,index)"
          >
            {{ lange == "Ch" ? "立即了解" : "すぐにわかる" }}
          </div> -->
        </div>
      </div>
      <div
        class="product_bottom"
        v-if="seriesPoster.length > 0 && seriesPoster[1]"
      >
        <Poster :ComponData="[seriesPoster[1]]"></Poster>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import { carouselByTitle, getClassifyList } from "@/api/api";
import Poster from "../components/Poster";
import Footer from "../components/Footer";
// import ProductCarousel from "../components/ProductCarousel.vue";
export default {
  components: {
    Poster,
    Footer,
  },
  // 定义属性
  data() {
    return {
      poster: [],
      seriesPoster: [],
      productData: [],
      height: 0,
      CategoryId: "",
      isPhone: document.body.clientWidth < 920,
    };
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 方法集合
  methods: {
    getCarouselByTitle() {
      let params = {
        title: this.detail.title || "",
      };
      carouselByTitle(params)
        .then((res) => {
          if (res.data.code == 0) {
            this.seriesPoster = res.data.data;
          }
        })
        .catch();
    },
    // 根据分类获取商品
    getClassifyList(min = 1, max = 30) {
      // 通过产品类别Id获取对应的产品列表
      let params = {
        productCategoryId: this.CategoryId,
        pageIndex: min,
        pageSize: max,
      };
      getClassifyList(params)
        .then((res) => {
          if (res.data.code == 0) {
            this.productData = res.data.data.data;
          }
        })
        .catch((err) => {
          this.poster = [];
          this.productData = "";
        });
    },
        onStarItemPage(id, item, index) {
      this.$router.push({
        name: "StarItem",
        query: {
         id: id,
          detail: JSON.stringify(item),
          isDetail: true,
          index: `2-${index}`,
          isDetail: true,
        },
      });
    },
    onProductDetail(id, item) {
      this.$router.push({
        name: "StarItem",
        query: {
          id: id,
          detail: JSON.stringify(item),
          isDetail: true,
        },
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  async created() {
    if (this.$route.query.id) {
      this.CategoryId = this.$route.query.id;
      this.detail = JSON.parse(this.$route.query.detail);
      this.poster = [{ imageUrl: this.detail.imageUrl }];
      this.getCarouselByTitle();
      this.getClassifyList();
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let height = this.isPhone ? 233 : 427;
    this.height = window.screen.availHeight - height;
  },
  watch: {
    $route(to) {
      this.CategoryId = to.query.id;
      this.detail = JSON.parse(to.query.detail);
      this.poster = [{ imageUrl: this.detail.imageUrl }];
      this.getCarouselByTitle();
      this.getClassifyList();
    },
  },
};
</script>

<style lang='less' scoped>
.mook_poster {
  max-width: 1440px;
  min-width: 1240px;
}
.product_poster {
  max-width: 1440px;
  min-width: 1240px;
}
.product_bottom {
  max-width: 1440px;
  min-width: 1240px;
  margin: 0 auto 112px;
}
.product {
  &_list {
    // max-width: 1440px;
    // min-width: 1240px;
    min-width: 1030px;
    max-width: 1040px;
    margin: 0 auto 80px;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;

  }
  &_item {
    max-width: calc((100% / 3) - 10px);
    width: 250px;
    text-align: center;
    margin-right: 140px;
    float: left;
    .product_image {
      width: 100%;
      height: 340px;
      overflow: hidden;
      background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    }
    .title {
      // padding: 10px 0;
      // border-bottom: 1px solid #876d4b;
      width: 100%;
      font-size: 16px;
      color: #212121;
      display: inline-block;
      margin: 20px auto;
      position: relative;
      overflow: hidden;

      .title_p{
        line-height: 26px;
         font-weight: bold;
         position: relative;
         z-index: 2;
      }
     .title_bg{
       position: absolute;
       top: 0;
       left: 0;
       width: 100%;
       height: 26px;
       background-image:linear-gradient(0deg,#eed593 45%,#fff 0);
     }
    }
    // .title::after{
    //   width: ;
    // }
    .price {
      font-size: 30px;
      font-weight: 400;
      color: #876d4b;
      line-height: 42px;
    }
    .comprehend {
      margin: 20px auto;
      width: 200px;
      height: 64px;
      background: #faecc7;
      line-height: 64px;
      font-size: 18px;
      font-weight: 400;
      color: #876d4b;
      cursor: pointer;
    }
  }
  &_item:nth-child(3n) {
    margin-right: 0;
  }
  &_item:nth-child(n+4) {
    margin-top: 30px;
  }

}
.series {
  &_title {
    font-weight: blod;
    color: #3e3a39;
    display: inline-block;
  }

  &_message {
    color: #878787;
    text-align: center;
  }
}
</style>
